import { APIResponse, cancellationPoliciesEndpoint, CancellationPolicy, useAppQuery } from '@alluradirect/react';

interface Args {
  pid: number | undefined;
}

export const usePropertyCancellationPolicy = ({ pid }: Args) => {
  return useAppQuery<APIResponse<{ CANCELLATION_POLICY: CancellationPolicy }>>({
    endpoint: `${cancellationPoliciesEndpoint}?id=${pid}`,
    enabled: Boolean(pid),
  });
};
